/* Owner-supplied cosmetic merchandising rules. No answer leaves this browser. */
(() => {
  const keys = ['region', 'need', 'wish', 'scent'];
  const options = {
    region: ['hair', 'face', 'hands', 'body'],
    need: ['oily', 'dry', 'flaky', 'demanding', 'balanced'],
    wish: ['clear', 'rich', 'gentle'],
    scent: ['herbal', 'floral', 'fruity', 'woody', 'any']
  };
  // One row per explicit source row; IDs refer to the stable supplied line number.
  const rows = [
    [26,'tea','face','oily','clear','*'],[27,'tea','face','oily','gentle','*'],[28,'tea','face','oily','rich','*'],[29,'tea','body','oily','clear','*'],
    [33,'goat','face','dry','gentle','*'],[34,'goat','face','dry','clear','*'],[35,'goat','face','flaky','gentle','*'],
    [36,'goat','hands','dry','gentle','*'],[37,'goat','hands','dry','clear','*'],[38,'goat','hands','flaky','gentle','*'],
    [39,'goat','body','dry','gentle','*'],[40,'goat','body','flaky','gentle','*'],
    [44,'argan','face','dry','rich','*'],[45,'argan','face','demanding','clear','*'],
    [46,'argan','face','demanding','rich','herbal,fruity,woody,any'],[47,'argan','face','demanding','gentle','herbal,fruity,woody,any'],
    [48,'argan','hands','dry','rich','herbal,any'],[49,'argan','hands','demanding','rich','*'],
    [50,'argan','body','demanding','rich','herbal,any'],[51,'argan','body','demanding','gentle','any'],
    [56,'rosemary','hair','*','*','*'],[58,'rosemary','hands','balanced','clear','herbal,any'],
    [59,'rosemary','body','balanced','clear','herbal,any'],[60,'rosemary','body','oily','clear','herbal,any'],
    [64,'rose','face','demanding','rich','floral'],[65,'rose','face','demanding','gentle','floral'],
    [66,'rose','face','balanced','gentle','floral'],[67,'rose','face','balanced','rich','floral'],
    [68,'rose','hands','dry','rich','floral'],[69,'rose','hands','balanced','gentle','floral'],[70,'rose','hands','balanced','rich','floral'],
    [71,'rose','body','dry','rich','floral'],[72,'rose','body','demanding','rich','floral'],[73,'rose','body','demanding','gentle','floral'],
    [74,'rose','body','balanced','gentle','floral'],[75,'rose','body','balanced','rich','floral'],
    [78,'mango','hands','dry','rich','fruity'],[79,'mango','hands','balanced','rich','fruity'],[80,'mango','hands','balanced','gentle','fruity'],
    [81,'mango','body','dry','rich','fruity'],[82,'mango','body','flaky','rich','fruity'],[83,'mango','body','demanding','rich','fruity'],
    [84,'mango','body','balanced','rich','fruity'],[85,'mango','body','balanced','gentle','fruity'],
    [88,'sandal','hands','dry','rich','woody'],[89,'sandal','hands','balanced','rich','woody'],[90,'sandal','hands','balanced','gentle','woody'],
    [91,'sandal','body','dry','rich','woody'],[92,'sandal','body','flaky','rich','woody'],[93,'sandal','body','demanding','rich','woody'],
    [94,'sandal','body','balanced','rich','woody'],[95,'sandal','body','balanced','gentle','woody']
  ];
  const rules = rows.map(([line, product, ...values]) => ({
    id: `source-${line}`, product, priority: 1,
    match: Object.fromEntries(keys.map((key, index) => [key, values[index] === '*' ? '*' : values[index].split(',')]))
  }));
  const equalRules = ['source-29','source-60'];
  function original(answers) {
    if (!keys.every(key => options[key].includes(answers[key]))) return { status: 'incomplete', ruleIds: [], products: [] };
    const matches = candidate => rules.filter(rule => keys.every(key => rule.match[key] === '*' || rule.match[key].includes(candidate[key])));
    let matched = matches(answers);
    let inheritedFromBody = false;
    // Owner-approved fallback changes only region, never need/wish/scent.
    // Exact matches (including hair/scalp) always retain priority.
    if (!matched.length && answers.region !== 'body') {
      matched = matches({ ...answers, region: 'body' });
      inheritedFromBody = matched.length > 0;
    }
    const ruleIds = matched.map(rule => rule.id);
    const products = [...new Set(matched.map(rule => rule.product))];
    if (products.length > 1 && !(ruleIds.length === 2 && equalRules.every(id => ruleIds.includes(id))))
      return { status: 'conflict', ruleIds, products: [] };
    return { status: products.length ? 'match' : 'no-rule', ruleIds, products, equal: products.length > 1, inheritedFromBody };
  }
  // Explicit cosmetic profiles: region, care and scent are hard gates, never random.
  // Existing care rules remain the fallback; a wildcard must not misrepresent scent.
  const originalScents = {
    tea:['herbal','woody'], goat:['floral'], argan:['floral'],
    rosemary:['herbal','woody'], rose:['floral'], mango:['fruity'], sandal:['woody'],
  };
  function scentChecked(previous, answers) {
    if (previous.status !== 'match' || answers.scent === 'any') return previous;
    const products = previous.products.filter(key => originalScents[key]?.includes(answers.scent));
    return {...previous, status:products.length ? 'match' : 'no-rule', products,
      equal:products.length > 1, ruleIds:products.length ? previous.ruleIds : []};
  }
  function evaluateExact(answers) {
    const previous = scentChecked(original(answers), answers);
    if (previous.status === 'incomplete' || answers.need === 'flaky') return previous;
    const matchesProfile = p =>
      p.regions.includes(answers.region) && p.needs.includes(answers.need) &&
      p.wishes.includes(answers.wish) && (answers.scent === 'any' || p.scents.includes(answers.scent));
    const catalog = globalThis.SkinCompassCatalog || [];
    const candidates = catalog.filter(p => !p.gapOnly && matchesProfile(p));
    // Small editorial priorities distinguish concrete daily routines, not random rotation.
    const priorities = {
      'body:balanced:rich:fruity':['avocado','apricot'],
      'body:balanced:clear:herbal':['eucalyptus','pine'],
      'hands:balanced:rich:any':['cocoaShea','vanilla'],
      'face:demanding:rich:any':['almond','pomegranate'],
      'face:dry:rich:any':['tripleButter','donkey'],
    }[keys.map(key => answers[key]).join(':')] || [];
    const rank = p => priorities.includes(p.key) ? priorities.indexOf(p.key) - 100 : p.needs.length;
    candidates.sort((a,b) => rank(a) - rank(b));
    if (!candidates.length) {
      if (previous.status === 'match') return previous;
      const additions = catalog.filter(p => p.gapOnly && matchesProfile(p));
      additions.sort((a,b) => rank(a) - rank(b));
      const products = [...new Set(additions.map(p => p.key))].slice(0,2);
      if (!products.length) return previous;
      return {status:'match', products, ruleIds:products.map(key => `gap-${key}`), equal:products.length > 1, inheritedFromBody:false};
    }
    const products = candidates.slice(0,2).map(p => p.key);
    return {status:'match', products, ruleIds:products.map(key => `catalog-${key}`), equal:products.length > 1, inheritedFromBody:false};
  }
  // Owner-approved shopping alternatives, not new skin-condition suitability rules.
  // Region and scent stay mandatory. Existing exact results always win.
  const alternativeKeys = ['nettle','berry','lavender','olive','aloe','pomegranate','tripleButter','donkey','baby','amber','argan','chamomile'];
  function evaluate(answers) {
    const exact = evaluateExact(answers);
    if (exact.status !== 'no-rule') return exact;
    const candidates = (globalThis.SkinCompassCatalog || []).filter(p =>
      alternativeKeys.includes(p.key) && p.regions.includes(answers.region) &&
      (answers.scent === 'any' || p.scents.includes(answers.scent)));
    const score = p => (p.needs.includes(answers.need) ? 8 : 0) +
      (p.wishes.includes(answers.wish) ? 4 : 0) +
      (['dry','flaky'].includes(answers.need) && p.wishes.includes('gentle') ? 2 : 0);
    candidates.sort((a,b) => score(b) - score(a));
    const products = [...new Set(candidates.map(p => p.key))].slice(0,2);
    if (!products.length) return exact;
    return {status:'match', products, ruleIds:products.map(key => `alternative-${key}`),
      alternative:true, equal:products.length > 1, inheritedFromBody:false};
  }
  function supportedOptions(answers, key) {
    const index = keys.indexOf(key);
    if (index < 0) return [];
    const prefix = {};
    for (const earlier of keys.slice(0, index)) {
      if (!options[earlier].includes(answers[earlier])) return [];
      prefix[earlier] = answers[earlier];
    }
    function canComplete(candidate, next) {
      if (next === keys.length) return evaluate(candidate).status === 'match';
      const nextKey = keys[next];
      return options[nextKey].some(value => canComplete({ ...candidate, [nextKey]: value }, next + 1));
    }
    // Later answers are deliberately ignored when the visitor goes back.
    return options[key].filter(value => canComplete({ ...prefix, [key]: value }, index + 1));
  }
  function select(state, key, value) {
    if (!options[key]?.includes(value)) return false;
    const index = keys.indexOf(key);
    if (index !== state.step) return false;
    if (!supportedOptions(state.answers, key).includes(value)) return false;
    if (state.answers[key] !== value) keys.slice(index + 1).forEach(later => delete state.answers[later]);
    state.answers[key] = value;
    state.step = index + 1;
    return true;
  }
  globalThis.SkinCompassModel = { version: '5-complete-cosmetic-guide', keys, options, rules, equalRules, evaluate, evaluateExact, original, originalScents, supportedOptions, select };
})();
